import { Injectable } from "@angular/core";
import { Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";


import { environment } from "../../../environments/environment";
import { ProgramListViewModel, DataTablesQuery, ResponseMessage } from "@models/common";
import { Program, ProgramPublicProfile } from "@models/program";
import { DeleteRequest } from "@models/requests";
import { ActNowDictionaryItem } from "@models/common";
import { ActNowHttp } from "../../act-now.http";


@Injectable()
export class ImportService {
    private headers = new Headers({
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Accept": "application/json;charset=UTF-8"
    });

    constructor(private http: ActNowHttp) { }

    import(data: FormData): Observable<ResponseMessage> {
        let options = { headers: new Headers({ "BypassContentType": undefined }) };
        return this.http.post(environment.apiUrl + "Program/Import", data, options)
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/import-tool/import.service.ts